import React, { Component } from 'react';
import Constantes from "../util/Constantes";

export default class Footer extends Component {
    render() {
        return (
          <footer>
            <div className="footer-background">
              <div className="footer-1"></div>
              <div>
                <div id="footerAct" className="mb-3 footer-text">
                  © Universidad Privada del Norte - 2021
                </div>
                <div className="footer-text">
                  Todos los Derechos Reservados - {Constantes().Version}
                </div>
              </div>
            </div>
          </footer>
        );
    }
}
